import {abilitiesPlugin} from '@casl/vue'
import ability from "@/core/plugins/ability";
// import {can as $can , cannot} from "@/core/plugins/ability";
// import { AnyAbility } from '@casl/ability';

//Check if active deactive show main part replace $can
export function can(permission, type = "active") {
  return window.Vue.$can(permission + ":" + type);
}

//check if permission type is in active or show
export function canView(permission) {
  return can(permission, "active") || can(permission, "show")
}

// check if permission type is show
export function justView(permission) {
  return can(permission, "show");
}

export function isShow(permission) {
  if (canView(permission)) {
    if (can(permission)) {
      return "active"
    }
    return "show"
  }

  return undefined;
}


function directiveIsShow(el, binding, vnode) {
  switch (isShow(binding.value)) {
    case "active":
      break;
    case 'show' :
      el.classList.add("opacity-60")
      break;

    default:
      el.style.display = "none";
      break;
  }

}


function directiveCan(el, binding, vnode) {


  if (!can(binding.value)) {
    el.style.visibility = 'hidden';
  }
}

function directiveCanView(el, binding, vnode) {
  if (!canView(binding.value)) {
    el.style.visibility = 'hidden';
    //vnode.elm.style.display = "none";
  }
}

function directiveStatus(el, binding, vnode) {
  if (canView(binding.value)) {
    if (!can(binding.value)) {
      el.classList.add("v-btn--disabled");
      el.disabled = true;
      // vnode.componentOptions.propsData.disabled = "";
    }
  } else {
    el.style.visibility = 'hidden'
  }
}


function install(Vue) {
  Vue.prototype.can = can
  Vue.prototype.canView = canView
  Vue.prototype.justView = justView
  Vue.prototype.isShow = isShow
  Vue.use(abilitiesPlugin, ability)

  Vue.directive('can', {
    bind: directiveCan,
    update: directiveCan
  })


  Vue.directive('isShow', {
    bind: directiveIsShow,
    update: directiveIsShow
  })

  Vue.directive('canView', {
    bind: directiveCanView,
    update: directiveCanView
  })

  Vue.directive('status', {
    bind: directiveStatus,
    update: directiveStatus
  })


}

export default {
  install,
  can
}